import {
  ACTIVO_NOTIFICACIONES,
  CLEAR_ALL,
  GETALL_NOTIFICACIONES,
  LOADING_GETALL_NOTIFICACIONES,
  PARAMS_NOTIFICACIONES,
  SET_LOGOUT,
} from '../../../store/Types';

const initialState = {
  all: [],
  activo: null,
  loadingGetAll: false,
  params: {},
};

export const notificacionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_NOTIFICACIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_NOTIFICACIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_GETALL_NOTIFICACIONES:
      return {
        ...state,
        loadingGetAll: action.payload,
      };
    case PARAMS_NOTIFICACIONES:
      return {
        ...state,
        params: action.payload,
      };
    case SET_LOGOUT || CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
